<template>
  <div>
    <div class="text-center">
      <h2 class="highlighted-color1">
        <span>{{ localTargeting.name }}</span>
      </h2>
    </div>
    <AlertWraper :content="content" :type="content_type" />
    <div class="">
      <template v-if="!isEdit">
        <h3 class="font-size-xRegular text-uppercase mb-3">{{ $t('general_data') }}</h3>
        <table class="table align-middle table-row-dashed fs-6 gy-2 dataTable">
          <tbody>
            <tr>
              <td><strong>{{ $t('name') }}</strong></td>
              <td>{{ localTargeting.name }}</td>
            </tr>
            <tr>
              <td><strong>{{ $t('advertiser') }}</strong></td>
              <td>{{ localTargeting.advertiser.name }}</td>
            </tr>
            <tr>
              <td><strong>{{ $t('type') }}</strong></td>
              <td>{{ localTargeting.type | formatCustomTargetingType }}</td>
            </tr>
            <tr>
              <td><strong>{{ $t('elements') }}</strong></td>
              <td>{{ localTargeting.value_count }}</td>
            </tr>
            <tr>
              <td><strong>{{ $t('status') }}</strong></td>
              <td>{{ localTargeting.status | formatStatus }}</td>
            </tr>
          </tbody>
        </table>

        <template v-if="localTargeting">
          <template v-if="values.length > 0">
            <h3 class="font-size-xRegular text-uppercase mb-3">{{ $t('values') }}</h3>
            <template v-if="localTargeting.exceeds_limit">
              <AlertWraper :content="$t('element_count_exceeds_limit')" type="warning" />
            </template>
            <ul>
              <li v-for="(value, index) in values" :key="index">{{ value.value }}</li>
            </ul>
          </template>
        </template>

        <div class="text-center mt-4">
          <Button class="btn-color10" @click="isEdit = true">{{ $t('edit') }}</Button>
        </div>
      </template>
      <template v-else>
        <UpsertCustomTargetingForm
          :targeting="localTargeting"
          :values="valuesValues"
          :type="localTargeting.type"
          @custom-targeting-updated="handleUpdated"
          @upsert-custom-targeting-error="handleError"
        />
      </template>
    </div>
  </div>
</template>

<script>

import CustomTargetingsService from '@/modules/custom-targetings/services/custom-targetings-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import UpsertCustomTargetingForm from '@/components/custom-targetings/UpsertCustomTargetingForm'

export default {
  name: 'CustomTargetingDetail',
  props: ['targeting'],
  components: {
    AlertWraper,
    Button,
    UpsertCustomTargetingForm
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      isEdit: false,
      loader: false,
      localTargeting: '',
      values: []
    }
  },
  created () {
    this.localTargeting = this.targeting
    this.getCustomTargeting()
  },
  computed: {
    valuesValues () {
      return this.values.map(item => {
        return item.value
      })
    }
  },
  methods: {
    /**
     * Get custom targeting
     */
    async getCustomTargeting () {
      if (this.targeting.exceeds_limit) return
      this.loader = true
      try {
        const targeting = await CustomTargetingsService.getCustomTargeting({ id: this.targeting.id, itemsPerPage: 100 })
        this.localTargeting = targeting
        this.values = targeting.values
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * Handle error
     */
    handleError (error) {
      this.content = parseErrorResponseToArray(error)
    },
    /**
     * Handle updated
     */
    handleUpdated (customTargeting) {
      this.reset()
    },
    /**
     * Reset
     */
    reset () {
      this.isEdit = false
      this.values = []
      this.content = null
      this.getCustomTargeting()
    }
  }
}
</script>
